import type { IProfile } from '../../../models/profile';

/**
 * Whether the student belongs to a school (team). Membership is what connects
 * a student to a school; a licence is what the school grants on top of it, so
 * a member without one is still connected.
 *
 * Profiles from a backend that predates `connectedTeams` fall back to licences,
 * the check this replaced.
 */
export function hasTeamConnection(profile: IProfile | null): boolean {
  if (!profile) return false;
  if (profile.connectedTeams) return profile.connectedTeams.length > 0;

  return Boolean(profile.licenses?.length);
}
